export default __webpack_public_path__ + "static/media/Ashoka_Attack.c277c918.png";